var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.6667 16.3333H19.6133L19.24 16.0183C20.5918 14.6464 21.3348 12.8948 21.3333 11.0833C21.3333 9.58349 20.825 8.11734 19.8727 6.87026C18.9204 5.62319 17.5669 4.65121 15.9833 4.07725C14.3996 3.50329 12.6571 3.35311 10.9759 3.64572C9.29472 3.93832 7.75047 4.66056 6.53841 5.72111C5.32636 6.78166 4.50094 8.13288 4.16653 9.6039C3.83213 11.0749 4.00376 12.5997 4.65971 13.9854C5.31567 15.371 6.4265 16.5554 7.85173 17.3886C9.27696 18.2219 10.9526 18.6667 12.6667 18.6667C14.8133 18.6667 16.7867 17.9783 18.3067 16.835L18.6667 17.1617V18.0833L25.3333 23.905L27.32 22.1667L20.6667 16.3333ZM12.6667 16.3333C9.34667 16.3333 6.66667 13.9883 6.66667 11.0833C6.66667 8.17834 9.34667 5.83334 12.6667 5.83334C15.9867 5.83334 18.6667 8.17834 18.6667 11.0833C18.6667 13.9883 15.9867 16.3333 12.6667 16.3333Z",
    fill: "#5B5B5B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.8b6b1655407ced71212631766ca4929a.svg";
export { ForwardRef as ReactComponent };